import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseStatsDto } from '../../../shared/modules/base/dtos/base-stats.dto';

/**
 * Vehicle insurances stats DTO
 */
@CaslSubject(AppSubjectEnum.VEHICLE_INSURANCE)
export class VehicleInsurancesStatsDto extends BaseStatsDto {
  pending!: number;
  approved!: number;
  rejected!: number;
  paid!: number;
  expired!: number;
}
